import React from 'react';

import InsightsContainer from './InsightsContainer';
import { InsightsDetail } from './InsightsDetail';

const InsightsPage: React.FC = () => (
    <InsightsContainer.Provider>
        <InsightsDetail/>
    </InsightsContainer.Provider>
);
export default InsightsPage;
